import type { FleetOverview } from "../api/types";

export default function SummaryCards({ overview }: { overview: FleetOverview }) {
    let onLatest = 0;
    let behind = 0;
    let mismatch = 0;
    for (const c of overview.clusters) {
        if (c.status === "green") onLatest++;
        else if (c.status === "yellow") behind++;
        else if (c.status === "red") mismatch++;
    }
    const openAlerts = overview.alerts.summaries.reduce((acc, s) => acc + s.total, 0);
    const severities = overview.alerts.severities.length > 0 ? overview.alerts.severities.join("/") : "alerting";
    return (
        <div className="summary">
            <Card label="Total Clusters" value={overview.clusters.length} hint="Number of clusters in this fleet." />
            <Card
                label="On Latest"
                value={onLatest}
                tone="green"
                hint="Clusters whose tracked versions all match the newest available (green)."
            />
            <Card
                label="Behind"
                value={behind}
                tone={behind > 0 ? "yellow" : undefined}
                hint="Clusters running an older version than the newest available (yellow)."
            />
            <Card
                label="Mismatches"
                value={mismatch}
                tone={mismatch > 0 ? "red" : undefined}
                hint="Clusters with an internal version mismatch — e.g. a chart/render version mismatch (red)."
            />
            <Card
                label="Open Alerts"
                value={openAlerts}
                tone={openAlerts > 0 ? "red" : undefined}
                hint={`Open ${severities} alerts across this fleet (from Grafana Cloud IRM).`}
            />
        </div>
    );
}

function Card({ label, value, tone, hint }: { label: string; value: number; tone?: "green" | "yellow" | "red"; hint?: string }) {
    return (
        <div className={`card ${tone ?? ""}`} title={hint}>
            <div className="label">{label}</div>
            <div className="value">{value}</div>
        </div>
    );
}
